import axios from "axios";
import * as HeaderFiles from "../../header/header";

const apiGetAllCompaniesListEndpoint = HeaderFiles.apiGetAllCompaniesListEndpoint;

// TYPES
export const SET_COMPANIES_LIST = "SET_COMPANIES_LIST";

// ACTION
export const getCompaniesList = (force = false) => async (dispatch, getState) => {
    try {
        const { companies } = getState().companyList;

        // ✅ prevent duplicate API calls
        if (companies.length > 0 && !force) {
            return companies;
        }

        const response = await axios.get(apiGetAllCompaniesListEndpoint);

        dispatch({
            type: SET_COMPANIES_LIST,
            payload: response.data
        });

        return response.data;

    } catch (error) {
        console.error("Redux companies fetch error:", error);
    }
};